<template>
  <v-layout row justify-center v-if="ticket">
    <v-dialog
      scrollable
      :value="passPreview"
      @input="$emit('update:passPreview', false)"
      width="500px"
      flat
    >
      <v-card flat>
        <v-card-title>
          <div>
            <h3>{{ $t("screener.monetization.pass_preview.title") }}</h3>
            <div class="py-1 body-1 greyDarken1--text">
              {{ $t("screener.monetization.pass_preview.subtitle") }}
            </div>
          </div>
          <v-spacer></v-spacer>
          <v-btn
            small
            dark
            icon
            color="grey lighten-1"
            class="mx-0"
            @click="$emit('update:passPreview', false)"
          >
            <v-icon small>$vuetify.icons.rms_close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="max-height: 450px;">
          <v-layout row wrap justify-center align-center>
            <v-card width="273px">
              <v-card-text v-if="ticket.name" class="text-xs-center pa-3">
                <h2 :style="{ color: companyTheme.primaryColor }">
                  {{ ticket.name }}
                </h2>
              </v-card-text>
              <v-divider v-if="ticket.name"></v-divider>
              <v-card-text v-if="ticket.price" class="text-xs-center">
                <div :style="{ color: companyTheme.secondaryColor }">
                  <span class="title px-1">{{
                    getCurrencySymbol(ticket.currency)
                  }}</span>
                  <span class="display-2">{{ ticket.price }}</span>
                </div>
              </v-card-text>
              <v-divider v-if="ticket.price"></v-divider>
              <v-card-text class="subheading greyDarken2--text">
                <div>
                  {{ ticket.description }}
                </div>
                <ul class="px-3 py-2">
                  <li>
                    {{
                      $t(
                        "screener.monetization.group_ticket.contains_screenings",
                        {
                          number_of_screening: ticket.screening_ids.length
                        }
                      )
                    }}
                  </li>
                  <li>
                    {{
                      $t("screener.monetization.group_ticket.valid_till", {
                        end_date: moment
                          .utc(ticket.purchasing_end_date)
                          .local()
                          .format("lll")
                      })
                    }}
                  </li>
                </ul>
                <div class="subheading mt-1">
                  <router-link class="blue--text" to="#">{{
                    $t("screener.view_detail.title")
                  }}</router-link>
                </div>
              </v-card-text>
              <v-card-text class="pt-0 text-xs-center">
                <v-btn dark :color="companyTheme.primaryColor">{{
                  $t("screener.btn.buy_ticket")
                }}</v-btn>
              </v-card-text>
            </v-card>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-3">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="$emit('update:passPreview', false)">{{
            $t("screener.btn.ok")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { currencySymbol } from "@/mixins/monetization";

export default {
  name: "GroupTicketPreview",
  props: {
    passPreview: {
      type: Boolean,
      default: false
    },
    ticket: {
      type: Object,
      default: null
    }
  },
  mixins: [currencySymbol],
  computed: {
    ...mapGetters("company", {
      currentCompany: "getSelectedCompany"
    }),
    companyTheme() {
      if (
        this.currentCompany &&
        this.currentCompany.custom_properties &&
        this.currentCompany.custom_properties.hasOwnProperty("theme")
      ) {
        return this.currentCompany.custom_properties.theme;
      }
    }
  }
};
</script>

<style>
</style>
